export default {
    getCountries(from = null){
        return axios.get('/api/v1/countries', {
            params: {
                from: from
            }
        })
        .then((response) =>  {
            return response.data;
        })
        .catch(function (error) {
            console.log(error);
        });
    }
}